import { createLoadingStatusActionGroupWithParameter } from '~/shared/helpers/loading-status-helper';
import { createAction, props } from '@ngrx/store';
import { EntityId, InvestmentOrder } from '@qvs/core';

const prefix = '[InvestmentOrders]';

export const {
  load: loadInvestmentOrders,
  success: loadInvestmentOrdersSuccess,
  failure: loadInvestmentOrdersFailure
} = createLoadingStatusActionGroupWithParameter<{ maxResults: number }>(prefix, 'investment orders');

export const {
  load: loadInvestmentOrder,
  success: loadInvestmentOrderSuccess,
  failure: loadInvestmentOrderFailure
} = createLoadingStatusActionGroupWithParameter<{ orderId: number }>(prefix, 'investment order');

export const loadInvestmentOrderOnlyIfNotLoadedYet = createAction(
  `${prefix} investment order only if not loaded yet`,
  props<{ orderId: number }>()
);

export const setInvestmentOrders = createAction(`${prefix} set investment orders`, props<{ entities: InvestmentOrder[] }>());
export const upsertInvestmentOrder = createAction(`${prefix} upsert investment order`, props<{ entity: InvestmentOrder }>());
export const clearCurrentOrder = createAction(`${prefix} clear current order`);
export const setCurrentOrderId = createAction(`${prefix} set current order ID`, props<{ orderId: EntityId }>());
